export default "Lav jeres egne skønne og nemme tjur-fugle med paptallerkener og farve!";